export const WIKI_REVIEWER_PHONE = "17755453912";
const REVIEW_ACCESS_TOKEN_KEY = "wiki_reviewer_access_token";

const normalizeMobile = (value) => String(value || "").replace(/\D/g, "");

export const getWikiLoginMobile = (userInfo = {}, token = "") => {
  const profileMobile = normalizeMobile(
    userInfo.mobile || userInfo.phone || userInfo.phonenumber || userInfo.username,
  );
  return profileMobile;
};

export const isWikiReviewerAccount = (userInfo = {}, token = "") => {
  const normalizedToken = String(token || "");
  const serverVerified = normalizedToken && localStorage.getItem(REVIEW_ACCESS_TOKEN_KEY) === normalizedToken;
  return serverVerified || getWikiLoginMobile(userInfo, token) === WIKI_REVIEWER_PHONE;
};

export const rememberWikiReviewerAccess = (token = "", allowed = false) => {
  if (allowed && token) {
    localStorage.setItem(REVIEW_ACCESS_TOKEN_KEY, String(token));
  } else {
    localStorage.removeItem(REVIEW_ACCESS_TOKEN_KEY);
  }
};
